import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateCityEdit = {
  cityEdit: { data: null, loading: false, error: null },
};

export const cityEdit = createAsyncThunk('user/cityEdit', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .post(`/city/update/${data.id}`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerCityEdit = {
  [cityEdit.pending]: (state) => {
    state.cityEdit.loading = true;
  },
  [cityEdit.fulfilled]: (state, action) => {
    state.cityEdit.loading = false;
    state.cityEdit.data = action.payload;
    state.cityEdit.error = null;
  },
  [cityEdit.rejected]: (state, action) => {
    state.cityEdit.data = null;
    state.cityEdit.loading = false;
    state.cityEdit.error = action.payload;
  },
};
